<template>
<div class="container">
    <Header title="我的门票" />
    <van-tabs ref="tabs" color="#7181EB" title-active-color="#7181EB" v-model="active">

        <van-tab :title="item.title" v-for="(item, index) in navArray" :key="index">
            <my-ticket-tab @onRefresh="_requestNavDataSources" :item="item" :status="item.status" :active="active" />
        </van-tab>

    </van-tabs>
</div>
</template>

<script>
import Header from '@/components/Header'
import MyTicketTab from '@/components/ticket/MyTicketTab'
export default {
    components: {
        Header,
        MyTicketTab,
    },
    data() {
        return {
            loading: false,
            navArray: [
                {
                    count: 0,
                    title: this.Constants.TICKET_TITLE0,
                    status: this.Constants.TICKET_STATUS0,
                },
                {
                    count: 0,
                    title: this.Constants.TICKET_TITLE2,
                    status: this.Constants.TICKET_STATUS2,
                },
            ],
            active: 0,
        };
    },
    created() {},
    mounted() {
        this._requestNavDataSources();
    },
    methods: {
        async _requestNavDataSources() {
            let url = this.API.ticket_agent_ticket;
            let data = {};
            this.loading = true;
            const result = await this.$post(url, data);
            this.loading = false;
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.navArray = result.data.navArray;
            }
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    flex: 1;

    .scrollerView {
        position: relative;
        width: 100%;
        height: calc(100vh - 100px);
    }

    .scroller {
        background: #F8F8F8;
    }

    .service {
        position: fixed;
        right: 15px;
        bottom: 100px;
        width: 55px;
        height: 55px;
    }

    .footer {
        margin: 10px 15px;
        height: 40px;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        color: #fff;
    }
}
</style>
